import { getUserInfo, logOut, PWARewardAPI } from "@/api/user";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useGameStore } from "./games";
import { getPWADomainInfo, getTodayRewards } from "@/api/common";
import { Capacitor } from "@capacitor/core";

export const useUserStore = defineStore("user", () => {
  const balance = ref(0);
  const nickname = ref("");
  const id = ref(0);
  const loginAccount = ref("")
  const headimg = ref("")
  const unreadCount = ref(0)
  const unreadMsgIdList = ref<{ id: number;[key: string]: any }[]>([])
  const unreadActivityMsgList = ref([])
  const totalMsgListCount = ref(0)
  const gameStore = useGameStore()
  const acceptFirstRechargeBonus = ref(0)
  const isFirstRechargeRewardEligible = ref(false)
  const takeFirstDeposit = ref(false)
  const isHighestVIPlevel = ref(false)
  const VIPData = ref({
    cumulativeBetTotal: 0,
    currentLevel: 0,
    nextLevel: 0,
    bet_min: 0
  })
  const PWAConvertData = ref({
    canReceiveReward: 0,
    isPwaClaimed: 0,
    config: {
      isOpen: 0,
      rewardCoin: 0,
      popupMessage: '',
      popupDuration: 0,
      Id: '',
    }
  })
  const PWAPopupShowTimes = ref("")
  const PWAdomainInfo = ref({
    domainName: "",
    websiteDomain: ""
  })
  const withdrawSetting = ref({
    userName: "",
    phone: "",
    email: "",
    cpf: "",
    cnpj: "",
    cpfId: "",
    status: "",
    isEditable: ""
  })
  const dailyTreasure = ref({
    state: '',
    header: '',
    sub_header: '',
    description: ''
  })
  const returnTreasure = ref({
    return_treasure_chest_activity: false,
    return_treasure_chest_reward: {
      header: '',
      sub_header: '',
      description: ''
    }

  })
  const loginTreasure = ref(({
    state: false,
    header: '',
    sub_header: '',
    description: ''
  }))
  const nextdayTreasure = ref(({
    state: false,
    header: '',
    sub_header: '',
    description: ''
  }))
  const pwaShowing = ref(false)
  const isInHome = ref(true)
  const allActivityBonusPopup = ref(false)
  const claimActivityList = ref<any>([])
  const isOpenClaimPopup = ref(false)
  const vipAvailable = ref(true)
  const pendingBackendRecharge = ref({
    config: <any>{},
    id: '',
    topUpAmount: 0
  })

  const resetUserData = () => {
    balance.value = 0;
    nickname.value = "";
    id.value = 0;
    loginAccount.value = "";
    headimg.value = "";
    unreadCount.value = 0;
    unreadMsgIdList.value = [];
    unreadActivityMsgList.value = [];
    totalMsgListCount.value = 0;
    acceptFirstRechargeBonus.value = 0
    isFirstRechargeRewardEligible.value = false
    takeFirstDeposit.value = false
    isHighestVIPlevel.value = false
    VIPData.value = {
      cumulativeBetTotal: 0,
      currentLevel: 0,
      nextLevel: 0,
      bet_min: 0
    }
    PWAConvertData.value = {
      canReceiveReward: 0,
      isPwaClaimed: 0,
      config: {
        isOpen: 0,
        rewardCoin: 0,
        popupMessage: '',
        popupDuration: 0,
        Id: '',
      }
    }
    PWAPopupShowTimes.value = ""
    PWAdomainInfo.value = {
      domainName: "",
      websiteDomain: ""
    }
    withdrawSetting.value = {
      userName: "",
      phone: "",
      email: "",
      cpf: "",
      cnpj: "",
      cpfId: "",
      status: "",
      isEditable: ""
    }
    dailyTreasure.value = {
      state: '',
      header: '',
      sub_header: '',
      description: ''
    }
    returnTreasure.value = {
      return_treasure_chest_activity: false,
      return_treasure_chest_reward: {
        header: '',
        sub_header: '',
        description: ''
      }
    }
    loginTreasure.value = {
      state: false,
      header: '',
      sub_header: '',
      description: ''
    }
    nextdayTreasure.value = {
      state: false,
      header: '',
      sub_header: '',
      description: ''
    }
    pwaShowing.value = false
    isInHome.value = true
    allActivityBonusPopup.value = false
    claimActivityList.value = []
    isOpenClaimPopup.value = false
    vipAvailable.value = true
    pendingBackendRecharge.value = {
      config: {},
      id: '',
      topUpAmount: 0
    }
    localStorage.setItem("token", '');
    gameStore.resetGroupList()
    localStorage.setItem('footerPopupOpen', String(0))
    localStorage.setItem('ignoreDate', '');
  }

  const signOut = async (): Promise<void> => {
    try {
      const res = await logOut();
      if (res) {
        resetUserData()
        location.reload()
        sessionStorage.setItem('openPromotionPopup', '');
        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    } catch (error) {
      console.error("logout failed:", error);
    }


  }

  const getInfo = async (): Promise<void> => {
    try {
      const res = await getUserInfo();
      if (res) {
        const data = res.data;
        nickname.value = data?.user?.nickname || "";
        id.value = data?.user?.id || 0;
        balance.value = data?.user_account?.coin || 0;
        loginAccount.value = data?.user?.loginAccount || "";
        headimg.value = data?.user?.headimg || "";
        acceptFirstRechargeBonus.value = data?.user?.acceptFirstRechargeBonus || 0
        VIPData.value = {
          cumulativeBetTotal: data?.user_daily?.cumulativeBetTotal || 0,
          currentLevel: data?.user_account?.vip || 0,
          nextLevel: data?.user_next_vip?.level || 0,
          bet_min: data?.user_next_vip?.bet_min || 0

        }
        withdrawSetting.value = {
          userName: data?.withdraw_settings?.userName || "",
          phone: data?.withdraw_settings?.phone || "",
          email: data?.withdraw_settings?.email || "",
          cpf: data?.withdraw_settings?.cpf || "",
          cnpj: data?.withdraw_settings?.cnpj || "",
          cpfId: data?.withdraw_settings?.cpfId || "",
          status: data?.withdraw_settings?.status || "",
          isEditable: data?.withdraw_settings?.isEditable || ""
        }
        isHighestVIPlevel.value = data?.is_highest_vip_level
        returnTreasure.value = data?.return_treasure_chest_info || {}
        dailyTreasure.value = data?.daily_treasure_chest_info || {}
        loginTreasure.value = data?.login_treasure_chest_info || {}
        nextdayTreasure.value = data?.next_day_treasure_chest_info || {}
        allActivityBonusPopup.value = data?.allActivityBonusPopup == 1 ? true : false || false
        vipAvailable.value = data?.vip_available
        pendingBackendRecharge.value = data?.pendingManualBackendRecharge
        if (allActivityBonusPopup.value) {
          getClaimActivityList()
        }
        PWAConvertData.value = data?.pwa_info
        const isNativeApp = Capacitor.isNativePlatform();
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
        //  console.log("app claim auto---", data?.pwa_info?.canReceiveReward);
        if ((isStandalone || isNativeApp) && data?.pwa_info?.canReceiveReward === 0) {
          getPWARewardAPI()
        }

        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    } catch (error) {
      console.error("getUserInfo failed:", error);
    }
  };

  const getPWAInfo = async (): Promise<void> => {
    try {
      const res = await getPWADomainInfo();
      if (res) {
        const data = res.data;
        PWAdomainInfo.value = res.data

        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    } catch (error) {
      console.error("getUserInfo failed:", error);
    }
  };

  const getPWARewardAPI = async () => {
    try {
      const data = {
        uid: id.value
      }
      const res = await PWARewardAPI(data);
      if (res) {
        getInfo();
      }
    } catch (error) {
      console.error("getPWAReward failed:", error);
    }
  }

  const setRemainUnreadMsgList = (list: any) => {
    unreadMsgIdList.value = list
    unreadCount.value = unreadMsgIdList.value.length
  }

  const setMsgList = (list: any) => {
    const mergedList = [...unreadMsgIdList.value, ...list];
    unreadMsgIdList.value = Array.from(new Set(mergedList));
    unreadCount.value = unreadMsgIdList.value.length
  }

  const setActivityMsgList = (list: any) => {
    unreadActivityMsgList.value = Array.from(new Set(list));
    const allMsgs = list.flatMap((item: any) => item.msgList);
    totalMsgListCount.value = allMsgs.length
  }

  const reSetUnreadMessages = () => {
    unreadCount.value = 0
    unreadMsgIdList.value = []
  }

  const setFirstRechargePopupShowStatus = (data: any) => {
    acceptFirstRechargeBonus.value = data
  }

  const setisFirstRechargeRewardEligible = (data: any) => {
    isFirstRechargeRewardEligible.value = data
  }

  const setTakeFirstDeposit = (data: any) => {
    takeFirstDeposit.value = data
  }

  const setPWAPopupShowTimes = (data: any) => {
    PWAPopupShowTimes.value = data
  }

  const setPWAInfo = (data: any) => {
    PWAdomainInfo.value = data
  }

  const setPwaShowing = (data: boolean) => {
    pwaShowing.value = data
  }

  const setIsInHome = (data: any) => {
    isInHome.value = data == 0 ? true : false
  }

  const getClaimActivityList = async () => {
    try {
      const res = await getTodayRewards();
      setIsClaimActivityList(res.data)
    } catch (error) {
      console.error("getPWAReward failed:", error);
    }
  }

  const setIsClaimActivityList = (list: any) => {
    claimActivityList.value = list || []
  }

  const setIsOpenClaimPopup = (list: any) => {
    isOpenClaimPopup.value = list
  }
  return {
    balance,
    nickname,
    id,
    loginAccount,
    headimg,
    unreadCount,
    unreadMsgIdList,
    unreadActivityMsgList,
    totalMsgListCount,
    acceptFirstRechargeBonus,
    isFirstRechargeRewardEligible,
    VIPData,
    PWAConvertData,
    PWAPopupShowTimes,
    PWAdomainInfo,
    withdrawSetting,
    isHighestVIPlevel,
    dailyTreasure,
    returnTreasure,
    loginTreasure,
    nextdayTreasure,
    pwaShowing,
    isInHome,
    allActivityBonusPopup,
    claimActivityList,
    isOpenClaimPopup,
    vipAvailable,
    takeFirstDeposit,
    pendingBackendRecharge,
    getInfo,
    signOut,
    getPWARewardAPI,
    setRemainUnreadMsgList,
    setMsgList,
    reSetUnreadMessages,
    resetUserData,
    setActivityMsgList,
    setFirstRechargePopupShowStatus,
    setisFirstRechargeRewardEligible,
    setPWAPopupShowTimes,
    getPWAInfo,
    setPWAInfo,
    setPwaShowing,
    setIsInHome,
    setIsClaimActivityList,
    setIsOpenClaimPopup,
    setTakeFirstDeposit
  };
}, {
  persist: true,
});
